/* eslint-disable */
export const slugify = function (text) {
  return text.toString().toLowerCase()
    .replace(/\s+/g, '-')           // Replace spaces with -
    .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
    .replace(/\-\-+/g, '-')         // Replace multiple - with single -
    .replace(/^-+/, '')             // Trim - from start of text
    .replace(/-+$/, '')             // Trim - from end of text
}

export const replaceSpecial = function (t) {
  var á="a", é="e", í="i", ó="o", ú="u", ñ="n", ä="a", ë="e", ï= "i", ö="o", ü="u",
  acentos=/[áéíóúñäëïöü]/g
  return t.replace(acentos, function($1){ return eval($1) })
}



// WEBPACK FOOTER //
// ./src/helpers/utils.js